import Vue from "vue";
import { GridPlugin, Page, Filter, Sort, Toolbar, Search, Edit, CommandColumn } from "@syncfusion/ej2-vue-grids";
import { CustomUrlAdaptor } from "@/syncfusion/CustomUrlAdaptor";
import { DataManager } from "@syncfusion/ej2-data";
import titleMixin from "@/mixins/title";
import gridMixin from "@/mixins/syncfusion/grid";
import spinnerMixin from "@/mixins/spinner";
import customerApi from "@/api/customers/customerApiHttp";
import { downloadFile } from "@/helpers/fileHelper";
import AppointmentsExportDialog from "@/components/Templates/Customer/AppointmentsExportDialog.vue";
import ExportMenu from "@/components/Templates/Grid/ExportMenu.vue";
Vue.use(GridPlugin);
export default Vue.extend({
    components: {
        "export-menu": ExportMenu,
        "appointments-export-dialog": AppointmentsExportDialog
    },
    mixins: [gridMixin, titleMixin, spinnerMixin],
    data() {
        return {
            title: this.$t("customers.customers"),
            data: new DataManager({
                url: process.env.VUE_APP_API_BASE_URL + "customers/grid-data",
                //insertUrl: process.env.VUE_APP_API_BASE_URL + "customers/grid-create",
                //updateUrl: process.env.VUE_APP_API_BASE_URL + "customers/grid-edit",
                removeUrl: process.env.VUE_APP_API_BASE_URL + "customers/grid-delete",
                adaptor: new CustomUrlAdaptor()
            }),
            filterOptions: { type: "Menu" },
            pageSettings: { pageSize: 10 },
            toolbarOptions: [
                {
                    text: this.$t("shared.add"),
                    tooltipText: this.$t("shared.add"),
                    prefixIcon: "e-add",
                    id: "Custom_Add"
                },
                { template: "#customers-export-menu" },
                "Search"
            ],
            exportMenuItems: [
                {
                    text: this.$t("customers.exportMenu.customers"),
                    id: "Custom_ExportCustomers"
                },
                {
                    text: this.$t("customers.exportMenu.appointments"),
                    id: "Custom_ExportAppointments"
                }
            ],
            sortOptions: {
                columns: [
                    { field: "Surname", direction: "Ascending" },
                    { field: "Name", direction: "Ascending" }
                ]
            },
            searchOptions: {
                fields: ["Name", "Surname", "FiscalCode", "Email"],
                operator: "contains"
            },
            editSettings: {
                allowEditing: false,
                allowAdding: false,
                allowDeleting: true,
                showDeleteConfirmDialog: true,
                mode: "Dialog"
            },
            commands: [
                {
                    type: "Appointments",
                    title: "Lista appuntamenti",
                    buttonOption: {
                        cssClass: "e-flat",
                        iconCss: "e-appointments e-icons"
                    }
                },
                {
                    type: "Attachments",
                    title: "Allegati",
                    buttonOption: {
                        cssClass: "e-flat",
                        iconCss: "e-folder-open e-icons"
                    }
                },
                {
                    type: "HealthPath",
                    title: "Percorsi",
                    buttonOption: {
                        cssClass: "e-flat",
                        iconCss: "e-resizer e-icons"
                    }
                },
                {
                    type: "Custom_Edit",
                    title: this.$t("shared.edit"),
                    buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" }
                },
                {
                    type: "Delete",
                    buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" }
                }
            ]
        };
    },
    provide: {
        grid: [Page, Filter, Sort, Toolbar, Search, Edit, CommandColumn]
    },
    methods: {
        toolbarClick(args) {
            if (args.item.id == "Custom_Add") {
                this.$router.push("/customers/create");
                return;
            }
        },
        exportMenuSelect(id) {
            if (id == "Custom_ExportCustomers") {
                this.exportCustomers();
                return;
            }
            if (id == "Custom_ExportAppointments") {
                this.$refs.appointmentsExportDialog.show();
                return;
            }
        },
        async exportCustomers() {
            this.showSpinner();
            try {
                const { file, fileName } = await customerApi.exportCustomers();
                downloadFile(file, fileName);
            }
            catch (errors) {
                this.$toast.showWarningToast(this.$t("shared.toastFailureTitle"), errors[0].message);
            }
            finally {
                this.hideSpinner();
            }
        },
        commandClick(args) {
            if (args.commandColumn.type == "Appointments") {
                this.$router.push("/customers/" + args.rowData.Id + "/appointments");
                return;
            }
            if (args.commandColumn.type == "Attachments") {
                this.$router.push("/customers/" + args.rowData.Id + "/attachments");
                return;
            }
            if (args.commandColumn.type == "HealthPath") {
                this.$router.push("/customers/" + args.rowData.Id + "/healthPath");
                return;
            }
            if (args.commandColumn.type === "Custom_Edit") {
                this.$router.push("/customers/" + args.rowData.Id + "/edit");
                return;
            }
        },
        actionComplete(args) {
            if (args.requestType === "delete") {
                this.$toast.showSuccessToast(this.$t("customers.delete.toastSuccessTitle"), this.$t("customers.delete.toastSuccessContent", {
                    name: `${args.data[0].Name} ${args.data[0].Surname}`
                }));
            }
        }
    }
});
